import en from './en';
import zhHans from './zh-Hans';

export const localeTextMap = {
    en,
    'zh-Hans': zhHans,
};

export type LocaleCode = keyof typeof localeTextMap;
export type LocaleText = (typeof localeTextMap)['zh-Hans'];

export const SUPPORT_LOCALES = Object.keys(localeTextMap);
